export default {
  title: 'אירועים לטיפול',
  empty: 'אין אירועים',
  eventTypes: {
    filename_problem: 'בעיה בשם קובץ',
    sheet_name_problem: 'בעיה בשם גיליון',
    import_problem: 'בעיה בקליטת הקובץ',
    new_agent_created: 'סוכן חדש נוצר אוטומטית',
  },
  filters: {
    eventType: 'סוג אירוע',
    errorCode: 'סוג שגיאה',
    all: 'הכל',
  },
  status: {
    open: 'פתוח',
    closed: 'סגור',
  },
  errorCodes: {
    NO_COMPANY: 'חברה לא זוהתה',
    NO_YEAR: 'שנה לא זוהתה',
    NO_MONTH: 'חודש לא זוהה',
    NO_REFERENCE_YEAR: 'שנת ייחוס לא זוהתה',
    AMBIGUOUS: 'מספר כללים תואמים',
    NO_RULE: 'חוק לא נמצא',
    SHEET_NOT_FOUND: 'גיליון לא נמצא',
    PROCESS_FAILURE: 'שגיאת עיבוד',
    MISSING_FILE: 'קובץ חסר לחוק',
    LOCKED_FILE: 'קובץ מוגן בסיסמה',
    UNREADABLE_FILE: 'קובץ לא קריא',
    IMPORT_RULE_FAILURE: 'שגיאת חוק ייבוא',
    NEW_AGENT_CREATED: 'סוכן חדש נוצר',
  },
  columns: {
    date: 'תאריך',
    type: 'סוג',
    errorCode: 'שגיאה',
    filename: 'שם קובץ',
    user: 'משתמש',
    status: 'סטטוס',
  },
  notification: {
    fetchError: { title: 'שגיאה', message: 'לא ניתן לטעון אירועים' },
  },
};
